import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import classnames from 'classnames';
import get from 'lodash/get';
import {
  trackContactFormOpen,
  trackPhoneCall,
  trackPhoneNumberReveal,
  addLead
} from '../../../store/actions/dataLayer';
import { listingPropTypes } from '../../../utils/commonPropTypes';
import { isFSBOContact } from '../../../utils/listingHelper';
import messages from '../../../utils/translationMessages';
import './styles.css';
import './inline.css';
import { BREAKPOINTS } from '../../../utils/commonHelper';

class ContactGroup extends PureComponent {
  state = {
    revealPhoneNumber: false
  };

  renderInline(phoneNumber, isFsbo) {
    const {
      intl: { formatMessage: t },
      breakpoint,
      hidden
    } = this.props;
    return (
      <div
        className={classnames('contact-group contact-group-in-line', {
          'hide': hidden
        })}
      >
        <button className="contact-button" onClick={this.handleContactOpen}>
          {t(messages.contactGroup.requestInformation)}
        </button>
        {!isFsbo && breakpoint === BREAKPOINTS.mobile && (
          <a
            className="call-button"
            href={`tel:${phoneNumber}`}
            onClick={this.handlePhoneCall}
          >
            {t(messages.contactGroup.callNow)}
          </a>
        )}
        {!isFsbo && breakpoint !== BREAKPOINTS.mobile && (
          <>
            {!this.state.revealPhoneNumber && (
              <a
                className={classnames('call-button')}
                href={`tel:${phoneNumber}`}
                onClick={this.handlePhoneReveal}
              >
                {t(messages.contactGroup.call)}
              </a>
            )}
            {this.state.revealPhoneNumber && (
              <div className={classnames('phone-number')}>
                {`${t(messages.contactGroup.call)}: `}
                <a href={`tel:${phoneNumber}`} onClick={this.handlePhoneCall}>
                  {phoneNumber}
                </a>
              </div>
            )}
          </>
        )}
      </div>
    );
  }

  render() {
    const {
      intl: { formatMessage: t }
    } = this.props;
    const phoneNumber = get(this.props, 'listing.contact.phone');
    const isFsbo = isFSBOContact(this.props.listing.contact);
    const isManufacturer = get(this.props, 'isManufacturer', false);

    if (this.props.mode === ContactGroup.MODES.inline) {
      return this.renderInline(phoneNumber, isFsbo);
    }

    return (
      <div
        className={classnames('contact-group', 'contact-group-sticky', {
          'show-icons': this.props.showIcons
        })}
      >
        <div
          className={classnames('contact-buttons', {
            'contact-buttons-manufacturer': isManufacturer,
            'single-contact-button': isFsbo || isManufacturer
          })}
        >
          <button
            className={classnames('contact-button', {
              'contact-button-fsbo': isFsbo
            })}
            onClick={this.handleContactOpen}
          >
            {t(messages.contactGroup.contact)}
          </button>
          {!isFsbo && !isManufacturer && (
            <>
              <a
                className={classnames('call-button', {
                  hide: this.state.revealPhoneNumber
                })}
                href={`tel:${phoneNumber}`}
                onClick={this.handlePhoneReveal}
              >
                {t(messages.contactGroup.call)}
              </a>
              <div
                className={classnames('phone-number', {
                  hide: !this.state.revealPhoneNumber
                })}
              >
                {`${t(messages.contactGroup.call)}: `}
                <a href={`tel:${phoneNumber}`} onClick={this.handlePhoneCall}>
                  {phoneNumber}
                </a>
              </div>
            </>
          )}
        </div>
      </div>
    );
  }

  handleContactOpen = () => {
    this.props.onOpenContact();
    if (this.props.isOpening === undefined || this.props.isOpening) {
      this.props.trackContactFormOpen();
    }
  };

  handlePhoneReveal = () => {
    this.props.trackPhoneNumberReveal();
    this.props.addLead(get(this.props, 'listing.id'), 'phone lead');
    this.setState({ revealPhoneNumber: true });
  };

  handlePhoneCall = () => {
    this.props.trackPhoneCall();
    this.props.addLead(get(this.props, 'listing.id'), 'phone lead');
  };
}

ContactGroup.MODES = {
  inline: 'inline',
  sticky: 'sticky'
};

ContactGroup.defaultProps = {
  mode: ContactGroup.MODES.sticky,
  showIcons: false,
  isManufacturer: false
};

ContactGroup.propTypes = {
  addLead: PropTypes.func.isRequired,
  intl: PropTypes.shape({
    formatMessage: PropTypes.func.isRequired
  }).isRequired,
  isOpening: PropTypes.bool,
  onOpenContact: PropTypes.func,
  showIcons: PropTypes.bool,
  listing: listingPropTypes,
  mode: PropTypes.oneOf(Object.keys(ContactGroup.MODES)),
  trackContactFormOpen: PropTypes.func.isRequired,
  trackPhoneCall: PropTypes.func.isRequired,
  trackPhoneNumberReveal: PropTypes.func.isRequired,
  breakpoint: PropTypes.oneOf(Object.keys(BREAKPOINTS)),
  hidden: PropTypes.bool,
  isManufacturer: PropTypes.bool
};

export default connect(null, (dispatch) =>
  bindActionCreators(
    {
      trackContactFormOpen,
      trackPhoneCall,
      trackPhoneNumberReveal,
      addLead
    },
    dispatch
  )
)(injectIntl(ContactGroup));
